import connectingBar from './components/ConnectingBar';

const STORAGE_CONNECTING_STATUS = 'sfConnectingStatus';

class ConnectingStatus {
  constructor(document, localStorage) {
    this.document = document;
    this.localStorage = localStorage;
    this.data = { isConnected: true };
  }

  load = () => {
    const storedItem = this.localStorage.getItem(STORAGE_CONNECTING_STATUS);
    this.data = JSON.parse(storedItem) || { isConnected: true };
  };

  clear = () => {
    this.localStorage.removeItem(STORAGE_CONNECTING_STATUS);
    this.data = { isConnected: true };
    this.redraw();
  };

  update = (result, isBroadcast) => {
    Object.assign(this.data, JSON.parse(result.data));
    if (!isBroadcast) {
      localStorage.setItem(STORAGE_CONNECTING_STATUS, result.data);
    }
    this.redraw();
  };

  redraw() {
    const currentBar = this.document.querySelector('.guuruConnectingBar');
    const textAreaSelector = '.embeddedServiceSidebar .chasitorInputWrapper textarea';

    if (this.isConnected) {
      if (currentBar) {
        currentBar.parentElement.removeChild(currentBar);
      }
      setTimeout(() => {
        const textArea = this.document.querySelector(textAreaSelector);
        if (textArea) {
          textArea.disabled = false;
        }
      });
    } else {
      const messageArea = this.document.querySelector(
        '.embeddedServiceSidebar div.messageArea',
      );
      const newBar = connectingBar({ message: this.text });
      if (currentBar) {
        currentBar.parentElement.replaceChild(newBar, currentBar);
      } else {
        messageArea.appendChild(newBar);
      }
      setTimeout(() => {
        const textArea = this.document.querySelector(textAreaSelector);
        if (textArea) {
          textArea.disabled = true;
        }
        messageArea.scrollTop = messageArea.scrollHeight;
      });
    }
  }

  get text() {
    return this.data.text;
  }

  get isConnected() {
    return !!this.data.isConnected;
  }
}

export default ConnectingStatus;
